import { defineChain } from 'viem'

export const base = defineChain({
  id: 8453,
  name: 'Base',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://mainnet.base.org'] },
  },
  blockExplorers: {
    default: { name: 'Basescan', url: 'https://basescan.org', apiUrl: 'https://api.basescan.org/api' },
  },
  contracts: {
    multicall3: { address: '0xca11bde05977b3631167028862be2a173976ca11', blockCreated: 5022 },
  },
  sourceId: 1,
})

const stubRpc = { default: { http: ['https://stub.invalid'] } }

export const mainnet = defineChain({ id: 1, name: 'Ethereum', nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 }, rpcUrls: stubRpc })
export const sepolia = defineChain({ id: 11155111, name: 'Sepolia', nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 }, rpcUrls: stubRpc })
export const baseSepolia = defineChain({ id: 84532, name: 'Base Sepolia', nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 }, rpcUrls: stubRpc })
export const optimism = defineChain({ id: 10, name: 'OP Mainnet', nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 }, rpcUrls: stubRpc })
export const optimismSepolia = defineChain({ id: 11155420, name: 'OP Sepolia', nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 }, rpcUrls: stubRpc })
export const arbitrum = defineChain({ id: 42161, name: 'Arbitrum One', nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 }, rpcUrls: stubRpc })
export const polygon = defineChain({ id: 137, name: 'Polygon', nativeCurrency: { name: 'POL', symbol: 'POL', decimals: 18 }, rpcUrls: stubRpc })
export const avalanche = defineChain({ id: 43114, name: 'Avalanche', nativeCurrency: { name: 'Avalanche', symbol: 'AVAX', decimals: 18 }, rpcUrls: stubRpc })
export const bsc = defineChain({ id: 56, name: 'BNB Smart Chain', nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 }, rpcUrls: stubRpc })
export const zora = defineChain({ id: 7777777, name: 'Zora', nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 }, rpcUrls: stubRpc })
